"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDatePicker = void 0;
const React = __importStar(require("react"));
const kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const __1 = require("../");
const ll_1 = require("../../languages/ll");
const styled_components_1 = __importDefault(require("styled-components"));
class ZDatePickerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.componentRef = React.createRef();
        this.boundClearHandler = this.clearHandler.bind(this);
        this.state = {
            value: props.value || props.defaultValue,
            hovered: false,
            focused: false
        };
    }
    componentDidMount() {
        const datePicker = this.componentRef && this.componentRef.current;
        const dateInput = datePicker && datePicker.dateInput && datePicker.dateInput.element;
        if (dateInput) {
            dateInput.addEventListener("click", () => {
                if (datePicker) {
                    datePicker.setState({
                        show: !datePicker.state.show
                    });
                }
            });
        }
    }
    clearHandler(event) {
        event.preventDefault();
        const datePicker = this.componentRef && this.componentRef.current;
        if (datePicker) {
            datePicker.setState({ value: null });
        }
        this.setState({ hovered: false, value: null });
        this.props.onChange &&
            this.props.onChange(event);
    }
    setValue(value) {
        const datePicker = this.componentRef && this.componentRef.current;
        if (datePicker) {
            datePicker.setState({ value });
        }
        this.setState({ hovered: false, value });
        this.props.onChange &&
            this.props.onChange({
                target: { value }
            }, value, false);
    }
    render() {
        const { label } = this.props, { languageId } = this.context;
        kendo_react_intl_1.loadMessages({
            datepicker: {
                toggleCalendar: ll_1.ll({
                    key: "ToggleCalendar",
                    languageId
                })
            },
            calendar: {
                today: ll_1.ll({
                    key: "Today",
                    languageId
                })
            }
        }, languageId);
        return (React.createElement(__1.RequiredDot, { required: this.props.required, raised: !!this.props.label, raisedTransform: "right-2 down-18", loweredTransform: "down-16" },
            React.createElement("span", { id: this.props.id, className: [
                    this.props.className,
                    "z-component z-datepicker",
                    this.props.disabled ? "disabled" : ""
                ].join(" ") },
                React.createElement("span", { className: "date-picker-label" }, ll_1.ll({ key: label || "", languageId })),
                React.createElement("div", { onMouseEnter: e => this.setState({ hovered: true }), onMouseLeave: e => this.setState({ hovered: false }), className: this.state.hovered ? "hovered" : "" },
                    React.createElement(kendo_react_intl_1.LocalizationProvider, { language: languageId },
                        React.createElement(kendo_react_dateinputs_1.DatePicker, Object.assign({}, this.props, { formatPlaceholder: {
                                day: "--",
                                month: "--",
                                year: "----"
                            }, ref: this.componentRef, value: this.props.value || undefined, defaultValue: this.props.defaultValue || undefined, onChange: e => {
                                this.setState({ value: e.target.value || null });
                                this.props.onChange && this.props.onChange(e);
                            }, onFocus: e => this.setState({ focused: true }), onBlur: e => this.setState({ focused: false }) }))),
                    this.state.value &&
                        this.state.hovered &&
                        !this.props.disabled ? (React.createElement("span", { className: "k-icon k-clear-value k-i-close z-clear-button", role: "button", tabIndex: -1, title: ll_1.ll({
                            key: "Clear",
                            languageId
                        }), onClick: this.boundClearHandler })) : null))));
    }
}
ZDatePickerComponent.contextType = ll_1.llContext;
exports.ZDatePicker = styled_components_1.default(ZDatePickerComponent) `
   & .k-widget {
      box-sizing: content-box;
      &.k-datepicker {
         position: relative;
         left: -9px;
         & .k-dateinput {
            position: relative;
            left: 2px;
         }
      }
   }
   & .date-picker-label {
      font-family: ${props => props.theme["font-family"]};
      font-size: 12px;
      top: 11px;
      left: 4px;
      position: relative;
      color: ${props => props.valid === false
    ? props.theme["alert-color"]
    : "rgba(0, 0, 0, 0.6)"};
      display: block;
   }
   &.disabled.disabled.disabled .date-picker-label {
      color: ${props => props.theme["disabled-color"]};
   }
   & .k-dateinput,
   & .k-select,
   & .k-dateinput .k-dateinput-wrap .k-input {
      margin: 0px 0px 0px 0px;
      font-family: ${props => props.theme["font-family"]};
      color: ${props => !props.value && !props.defaultValue
    ? "transparent !important"
    : props.valid === false
        ? props.theme["alert-color"] + " !important"
        : "rgba(0, 0, 0, 0.87)"};

      &:focus {
         color: rgba(0, 0, 0, 0.87) !important;
      }
      &:hover:not(:disabled),
      .hovered &:not(:disabled) {
         border-bottom-color: rgba(0, 0, 0, 0.87);
         background: ${props => props.valid === false
    ? props.theme["validation-background-color"]
    : props.theme["input-background-hover-color"]};
      }
   }
   padding: 10px;
   width: 200px;
   display: inline-block;
   & .z-clear-button {
      position: relative;
      left: -67px;
      opacity: 0.5;
      cursor: pointer;
   }
`;
//# sourceMappingURL=ZDatePicker.js.map